export default __webpack_public_path__ + "static/14-05861c193d2a6c43e8c341dbf0c19415.jpg";